/**
 * KB-META
 * Purpose: Phone number pipe
 * Role: ui.module
 * EntryPoints: if()
 * Inputs: nationalNumber.length === 10:unknown
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=pipes/phone-number.pipe; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
  standalone: true
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (!value) return '';

    // Convert to string and remove all non-numeric characters
    const phoneNumber = value.toString().replace(/\D/g, '');

    // Check phone number length
    if (phoneNumber.length === 10) {
      // Standard 10-digit US number: Format as (XXX) XXX-XXXX
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    } else if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
      // US number with country code: Format as +1 (XXX) XXX-XXXX
      return `+1 (${phoneNumber.slice(1, 4)}) ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7)}`;
    } else if (phoneNumber.length > 10) {
      // Other international number: Try to format with country code
      const countryCode = phoneNumber.slice(0, phoneNumber.length - 10);
      const nationalNumber = phoneNumber.slice(phoneNumber.length - 10);
      
      if (nationalNumber.length === 10) {
        return `+${countryCode} (${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
      }
    }
    
    // Return original value if it doesn't match expected patterns
    return value.toString();
  }
} 